import { create } from 'api/order/create';


export const order = {
  create,
};
